import { render, staticRenderFns } from "./Tours.vue?vue&type=template&id=00f0fe82&scoped=true&"
import script from "./Tours.vue?vue&type=script&lang=js&"
export * from "./Tours.vue?vue&type=script&lang=js&"
import style0 from "@/styles/super.css?vue&type=style&index=0&id=00f0fe82&prod&scoped=true&lang=css&"
import style1 from "@/styles/yachts_tours.scss?vue&type=style&index=1&id=00f0fe82&prod&lang=scss&scoped=true&"
import style2 from "./Tours.vue?vue&type=style&index=2&id=00f0fe82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f0fe82",
  null
  
)

export default component.exports